module.exports = __webpack_public_path__ + "img/SpeakingTestDirections.153fca2b.png";